import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../../index.css";
import { useParams, useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  BASE_FILE_URL,
  BASE_URL,
  customDeleteStyles,
  multiSelectStyle,
  typeData2,
} from "../../../constant";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import SensorImportPopup from "./SensorImportPopup";
import { typeData } from "../../../constant";
import AlarmSettings from "../alarm/AlarmSettings";
import { confirmAlert } from "react-confirm-alert";
import BtnLoader from "../../BtnLoader";
import AppContext from "../../../AppContext";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";

const AlarmKmRange = ({ label, value, t }) => (
  <div className="flex flex-col gap-2 text-xs lg:text-sm py-1 w-52 pr-3 border-r-2 border-zinc-700">
    <div className="text-white text-xs lg:text-sm font-medium">{label}</div>
    <div className="flex justify-between gap-2">
      <div className="flex">
        <div className="font-medium w-fit">{t("masters.fields.alrmRange")}</div>
        &nbsp;:&nbsp;
        <div className="">{value} KM</div>
      </div>
    </div>
  </div>
);
const AlarmInfo = ({ label, value, text, t }) => (
  <div className="flex flex-col gap-2 text-xs lg:text-sm py-1 w-52 pr-3 border-r-2 border-zinc-700">
    <div className="text-white text-xs lg:text-sm font-medium">{label}</div>
    <div className="flex justify-between gap-2">
      <div className="flex">
        <div className="font-medium w-fit">{t("masters.fields.value")}</div>
        &nbsp;:&nbsp;
        <div className="">{value}</div>
      </div>
      {/* <div className="flex">
        <div className="font-medium w-fit">{t("masters.fields.text")}</div>
        &nbsp;:&nbsp;
        <div className="">{text}</div>
      </div> */}
    </div>
  </div>
);

// AlarmLimit.js
const AlarmLimit = ({ label, min, max, t }) => (
  <div className="flex flex-col gap-2 text-xs lg:text-sm py-1 justify-between w-52 pr-3 border-r-2 border-zinc-700">
    <div className="flex">
      <label className="text-white text-xs lg:text-sm font-medium">
        {label}
      </label>
    </div>
    <div className="flex">
      <div className="flex gap-1">
        <label className="text-xs lg:text-sm w-1/2">
          {t("masters.fields.min")}
        </label>
        :<div className="ml-1">{min}</div>
      </div>
      <div className="flex gap-1 ml-6">
        <label className="text-xs lg:text-sm w-1/2">
          {t("masters.fields.max")}
        </label>
        :<div className="ml-1">{max}</div>
      </div>
    </div>
  </div>
);

export const AssetForm = () => {
  const assets = [];
  const { authCtx, darkMode } = useContext(AppContext);
  const { t } = useTranslation();
  const { id } = useParams();
  const defaultform = {
    name: "",
    description: "",
    Parent: "",
    active: true,
    properties: [
      {
        id: "0",
        name: "",
        type: "String",
        options: "",
      },
    ],
    parameters: [
      {
        id: "0",
        parameterId: "",
        name: "",
        type: "String",
      },
    ],
    sensors: [],
    alarms: [],
    childParamsDelete: [],
  };

  const [asset, setAsset] = useState(defaultform);
  const [parentData, setParentData] = useState();
  const [companies, setCompanies] = useState([]);
  // const [darkMode, setDarkMode] = useState(false);
  const [loading, setLoading] = useState({
    formLoading: false,
    imageLoading: false,
  });
  const navigate = useNavigate();

  const onValueChange = (e) => {
    setAsset({ ...asset, [e.target.name]: e.target.value });
  };

  const onCloseClick = (e) => {
    navigate(`/assettype`);
  };

  const validateParametersIds = async () => {
    const parameterIds = new Set();
    for (let i = 0; i < asset.parameters.length; i++) {
      const parameterId = asset.parameters[i].parameterId;
      if (parameterIds.has(parameterId)) {
        return true; // Found duplicate name
      }
      parameterIds.add(parameterId);
    }
    return false;
  };

  const onSubmit = async (e) => {
    try {
      const notValid = await validateParametersIds();

      if (asset.name === "") {
        toast.error("Asset Name required");
      } else if (notValid) {
        toast.error("Parameter Id must be unique");
      } else {
        setLoading((pre) => ({ ...pre, formLoading: true }));

        const response = await axios.post(
          `${BASE_URL}/AssetType/PostData`,
          asset
        );
        if (response.status === 200) {
          toast.success("Successfully updated Asset Type");

          if (!asset.id) {
            const newAssetId = response.data;
            setAsset({ ...asset, id: newAssetId, childParamsDelete: [] });
            navigate(`/assetform/${newAssetId}`);
          } else {
            setAsset({ ...asset, childParamsDelete: [] });
          }
        }
      }
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error(error.response.data);
      } else {
        toast.error("An error occurred");
      }
    } finally {
      setLoading((pre) => ({ ...pre, formLoading: false }));
    }
  };

  const onCheckBox = (e) => {
    setAsset((pre) => ({
      ...pre,
      [e.target.name]: e.target.checked,
      company:
        e.target.name === "companyAssign" && !e.target.checked
          ? null
          : pre.company,
      companyId: !e.target.checked ? null : pre.companyId,
    }));
  };

  const addProp = (e) => {
    setAsset({
      ...asset,
      properties: [...asset.properties, defaultform.properties[0]],
    });
  };

  const addParams = (e) => {
    setAsset({
      ...asset,
      parameters: [...asset.parameters, defaultform.parameters[0]],
    });
  };

  const handlePropertyChange = (event, id, type) => {
    const updatedArray = asset[type].map((d, index) => {
      if (index === id) {
        const updatedItem = { ...d, [event.target.name]: event.target.value };
        if (type === "parameters" && event.target.name === "parameterId") {
          updatedItem.parameterId = updatedItem.parameterId.replace(/\s/g, "");
        }
        return updatedItem;
      }
      return d;
    });

    setAsset({
      ...asset,
      [type]: updatedArray,
    });
  };

  const handlePropertyOptionChange = (event, id) => {
    const data = [];
    event.map((d) => data.push(d.value));
    const commaAddedData = data.join(",");
    setAsset({
      ...asset,
      properties: asset.properties.map((d, index) =>
        index === id ? { ...d, options: commaAddedData, optionsData: event } : d
      ),
    });
  };

  const handlePropertyTypeChange = (event, id, type) => {
    const updatedArray = asset[type].map((d, index) =>
      index === id ? { ...d, type: event.value } : d
    );

    setAsset({
      ...asset,
      [type]: updatedArray,
    });
  };

  const handleParentChange = (event) => {
    setAsset({
      ...asset,
      parentId: event.value.id,
      parentName: event.value.name,
      parentData: event.value,
    });
  };

  const onDelete = (index, type, onClose, childDelete) => {
    let updatedAsset = {
      ...asset,
      [type]: asset[type].filter((_, propertyIndex) => propertyIndex !== index),
      alarms:
        type === "parameters"
          ? asset.alarms.filter(
              (x) => x.parameterId !== asset.parameters[index].parameterId
            )
          : asset.alarms,
      childParamsDelete:
        childDelete && type === "parameters"
          ? asset.childParamsDelete
            ? [...asset.childParamsDelete, asset.parameters[index].id]
            : [asset.parameters[index].id]
          : asset.childParamsDelete,
    };
    setAsset(updatedAsset);
    onClose();
  };

  const parameterConfirmAlert = (index, type) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="popup w-64 p-2 rounded bg-neutral-900 shadow bg-gradient-to-b ">
            <p className="text-lg font-semibold text-slate-300 mb-2">Confirm</p>
            <p className="text-sm font-semibold text-slate-300">
              There are assets associated with it. Do you want to delete the
              parameter from the asset too?
            </p>
            <div className="flex justify-end text-sm font-medium gap-3 mt-4">
              <button
                onClick={() => onDelete(index, type, onClose, true)}
                className="px-3 py-1 bg-purple-700 text-slate-300 rounded-lg"
              >
                Yes
              </button>
              <button
                onClick={() => onDelete(index, type, onClose, false)}
                className="px-3 py-1 bg-white text-black rounded-lg"
              >
                No
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const loadData = async () => {
    let res = await axios.get(`${BASE_URL}/Lookup/getallassettypes`);
    setParentData(res.data);
  };

  const loadAsset = (companyData) => {
    axios.get(`${BASE_URL}/AssetType/${id}`).then(function (response) {
      const data = response.data;
      const optionDatas = data.properties.map((prps) => ({
        ...prps,
        optionsData:
          prps.options !== ""
            ? prps.options.includes(",")
              ? prps.options.split(",")
              : [prps.options]
            : [],
      }));

      setAsset({
        ...data,
        // company: companyData.find((x) => x.id === data.companyId),
        parentData: { id: data.parentId, name: data.parentName },
        properties: optionDatas.map((one) => ({
          ...one,
          optionsData: one.optionsData?.map((op) => ({ value: op, label: op })),
        })),
        parameters: data.parameters,
      });
    });
  };

  const onAlarmDelete = (e, id) => {
    setAsset((pre) => ({
      ...pre,
      alarms: pre.alarms.filter((_, index) => index !== id),
    }));
  };

  const onAlarmPopup = (item, selectedalarm) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <AlarmSettings
            setAlarmPopup={onClose}
            setState={setAsset}
            selectedParameter={item}
            alarmPopup={true}
            selectedAlarm={selectedalarm}
          />
        );
      },
    });
  };

  const onAddAlarm = (e, item) => {
    const selectedItem = { ...item, alarmParentId: item.parameterId };
    onAlarmPopup(selectedItem, null);
  };

  const onEditAlarm = (e, item, index, alarm) => {
    const selectedItem = { ...item, alarmParentId: item.parameterId };
    const selectedalarm = { ...alarm, index: index };
    onAlarmPopup(selectedItem, selectedalarm);
  };

  const handleFileChange = async (event, target) => {
    const acceptedRatio = 16 / 9; // The required aspect ratio (16:9)
    const selectedFile = event.target.files[0];
    // Check if a file was selected
    if (!selectedFile) {
      // No file selected
      toast.error("Please select an image.");
      return;
    }

    const image = new Image();
    image.src = URL.createObjectURL(selectedFile);

    image.onload = () => {
      const aspectRatio = image.width / image.height;
      if (
        target === "imageId" &&
        Math.abs(aspectRatio - acceptedRatio) >= 0.01
      ) {
        // Aspect ratio is not close enough to 16:9
        toast.error("Please select an image with a 16:9 aspect ratio.");
        return;
      }

      const formData = new FormData();
      formData.append("files", selectedFile);

      axios
        .post(`${BASE_URL}/Storage/file/upload`, formData, {
          headers: { "Content-Type": "image/svg+xml" },
        })
        .then((res) => {
          setAsset((pre) => ({ ...pre, [target]: res.data[0].id }));
        })
        .catch((error) => {
          // Handle the upload error
          console.error("Error occurred during upload:", error.message);
        });
    };
  };

  const handleCompanyChange = (e) => {
    setAsset((pre) => ({ ...pre, company: e.value, companyId: e.value.id }));
  };

  const handleClick = (item, index) => {
    if (item.id !== "0") parameterConfirmAlert(index, "parameters");
    else onDelete(index, "parameters");
  };

  const loadLookupData = async () => {
    let res = await axios.get(`${BASE_URL}/api/CompanyMaster`);
    if (res.status === 200) {
      const data = res.data;
      setCompanies(data);
      return data;
    }
  };

  useEffect(() => {
    const loadDatas = async () => {
      loadData();
      const companyData = await loadLookupData();
      if (id !== "new") {
        loadAsset(companyData);
      } else
        setAsset((pre) => ({
          ...pre,
          company: companyData.find((x) => x.id === authCtx.profile.companyId),
          companyId: authCtx.profile.companyId,
        }));
    };
    loadDatas();
  }, []);

  return (
    <div className="flex flex-col relative text-white px-14 py-7 dark:bg-darkModeBg bg-lightModeBg h-full overflow-y-scroll">
      <div className="flex text-sm font-medium gap-3 items-center justify-between w-[64.5vw]">
        <div className="flex gap-3">
          <button type="button" onClick={onCloseClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2.0"
              stroke={darkMode ? "white" : "black"}
              className="w-7 h-7"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          </button>
          <label className="text-xs lg:text-2xl dark:text-white text-labels">
            {t("masters.headerTexts.assetTemplate")}
          </label>
        </div>
      </div>
      <div className="flex flex-row text-xs font-medium py-4 gap-4">
        <div className="flex flex-col">
          <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
            {t("masters.fields.name")}
            <span className=" text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            name="name"
            placeholder="Enter Name"
            value={asset.name}
            onChange={onValueChange}
            className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-80 h-9"
          />
        </div>
        <div className="flex flex-col">
          <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
            {t("masters.fields.description")}
          </label>
          <input
            type="text"
            name="description"
            value={asset.description}
            onChange={onValueChange}
            placeholder="Enter Description"
            className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-80 h-9"
          />
        </div>

        <div className="flex flex-col ml-[-2px]" id="parentcombo">
          <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
            {t("masters.fields.parent")}
          </label>
          <div className={`w-80 ${darkMode ? "darkCombo" : "lightCombo"}`}>
            <ComboBox
              data={parentData}
              dataItemKey="id"
              textField="name"
              name="parentName"
              placeholder="Parent"
              suggest={true}
              clearButton={false}
              style={{
                fontWeight: 500,
                fontSize: "12px",
              }}
              className=" block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light dark:text-white text-inputFieldsTxts rounded-lg mb-4 w-40 lg:w-80 h-9"
              onChange={handleParentChange}
              value={
                asset?.parentId
                  ? parentData.find((x) => x.id === asset.parentId)
                  : null
              }
            />
          </div>
        </div>
      </div>
      <div className="flex w-full">
        <div className="flex flex-col">
          <div className="flex justify-between w-full text-xs lg:text-sm font-medium gap-3 items-center">
            <label className="text-base dark:text-white text-labels">
              {t("masters.headerTexts.props")}
            </label>
          </div>
          <div className="flex flex-col text-xs font-medium py-4">
            {asset.properties.map((item, index) => (
              <div className="flex gap-3" id={item.id}>
                <div className="flex flex-col">
                  <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                    {t("masters.fields.name")}
                  </label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-48 h-9"
                    value={item.name}
                    onChange={(e) =>
                      handlePropertyChange(e, index, "properties")
                    }
                  />
                </div>
                <div className="flex flex-col" id="propTypecombo">
                  <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                    {t("masters.fields.type")}
                  </label>
                  <div className={`${darkMode ? "darkCombo" : "lightCombo"}`}>
                    <ComboBox
                      data={typeData}
                      name="type"
                      suggest={true}
                      style={{ fontSize: "12px", fontWeight: "500" }}
                      clearButton={false}
                      className=" block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light px-4 dark:text-white text-inputFieldsTxts rounded-lg mb-4 w-40 lg:w-44 h-9"
                      onChange={(e) =>
                        handlePropertyTypeChange(e, index, "properties")
                      }
                      value={item.type}
                    />
                  </div>
                </div>
                <div className="flex flex-col" id="propMultiSelect">
                  <label className="dark:text-white text-labels dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts text-xs lg:text-sm font-medium py-2">
                    {t("masters.fields.options")}
                  </label>
                  <div className="flex gap-3" id="compo">
                    <div
                      className={`${
                        darkMode
                          ? "darkCreatableSelect"
                          : "lightCreatableSelect"
                      }`}
                    >
                      <CreatableSelect
                        isMulti
                        options={assets}
                        name="options"
                        {...multiSelectStyle}
                        className="dark:text-white text-inputFieldsTxts dark:bg-zinc-700 bg-inputFields rounded-xl w-[12.5rem] lg:w-[33.63rem] h-9"
                        value={item.optionsData}
                        onChange={(e) => handlePropertyOptionChange(e, index)}
                      />
                    </div>
                    <div className="flex h-9 w-9  dark:bg-neutral-800 bg-neutral-500 justify-center items-center rounded-lg">
                      <button
                        type="button"
                        onClick={(e) => onDelete(index, "properties")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke={darkMode ? "white" : "black"}
                          class="w-4 h-4"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                          />
                        </svg>
                      </button>
                    </div>
                    {index === asset.properties.length - 1 ? (
                      <button
                        button="button"
                        className=" dark:bg-neutral-800 bg-neutral-500 px-6 h-9 py-2 rounded-md"
                        onClick={(e) => addProp(e)}
                      >
                        <div className="flex justify-center items-center rounded-lg gap-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="grey"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-4 h-4"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M12 4.5v15m7.5-7.5h-15"
                            />
                          </svg>
                          <label className="text-xs lg:text-sm font-medium">
                            {t("button.newProp")}
                          </label>
                        </div>
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="flex text-xs w-full justify-between lg:text-sm font-medium gap-3 items-center">
            <label className="text-base dark:text-white text-labels">
              {t("masters.headerTexts.params")}
            </label>
          </div>
          <div className="flex flex-col text-xs font-medium py-4">
            {asset.parameters.map((item, index) => (
              <div className="flex flex-col">
                <div className="flex gap-3" id={item.id}>
                  <div className="flex flex-col">
                    <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2 flex">
                      {t("masters.fields.id")}
                      <span className=" text-red-600 ml-1">*</span>
                    </label>
                    <input
                      type="text"
                      name="parameterId"
                      placeholder="Parameter Id"
                      className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-48 h-9"
                      value={item.parameterId}
                      disabled={item.id !== "0"}
                      onChange={(e) =>
                        handlePropertyChange(e, index, "parameters")
                      }
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                      {t("masters.fields.name")}
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-48 h-9"
                      value={item.name}
                      onChange={(e) =>
                        handlePropertyChange(e, index, "parameters")
                      }
                    />
                  </div>
                  <div className="flex flex-col" id="propTypecombo">
                    <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-2">
                      {t("masters.fields.type")}
                    </label>
                    <div className={`${darkMode ? "darkCombo" : "lightCombo"}`}>
                      <ComboBox
                        data={typeData}
                        name="type"
                        suggest={true}
                        clearButton={false}
                        style={{ fontSize: "12px", fontWeight: "500" }}
                        className=" block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light dark:text-white text-inputFieldsTxts rounded-lg mb-4 w-40 lg:w-44 h-9"
                        onChange={(e) =>
                          handlePropertyTypeChange(e, index, "parameters")
                        }
                        value={item.type}
                      />
                    </div>
                  </div>
                  {/* <div className="flex h-9 w-9 ml-3 mt-9 bg-neutral-800 justify-center items-center rounded-lg">
                    <button
                      type="button"
                      onClick={(e) => onDelete(index, "parameter")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-4 h-4"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                        />
                      </svg>
                    </button>
                  </div> */}
                  <div className="flex h-9 w-9 ml-3 mt-9 dark:bg-neutral-800 bg-neutral-500 justify-center items-center rounded-lg">
                    <ReactSVG
                      src="delete-icon.svg"
                      className="w-4 flex items-center justify-center"
                      beforeInjection={(svg) => {
                        svg.setAttribute(
                          "style",
                          `stroke: ${darkMode ? "white" : "black"}`
                        );
                      }}
                    />
                  </div>
                  <button
                    button="button"
                    className=" dark:bg-neutral-800 bg-neutral-500 w-40 h-9 mt-9 rounded-md disabled:opacity-40"
                    onClick={(e) => onAddAlarm(e, item)}
                    disabled={
                      asset?.alarms?.find(
                        (x) => x.parameterId === item.parameterId
                      ) ||
                      item.name === "" ||
                      item.parameterId === ""
                    }
                  >
                    <div className="flex justify-center items-center rounded-lg gap-2">
                      <img src="plus-icon.svg" className="h-5 text-white" />
                      <label className="text-xs lg:text-sm font-medium">
                        {item.alarm
                          ? t("button.editAlrm")
                          : t("button.addAlrm")}
                      </label>
                    </div>
                  </button>
                  {index === asset.parameters.length - 1 ? (
                    <button
                      button="button"
                      className="dark:bg-neutral-800 bg-neutral-500 px-6 h-9 mt-9 py-2 rounded-md"
                      onClick={(e) => addParams(e)}
                    >
                      <div className="flex justify-center items-center rounded-lg gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="grey"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-4 h-4"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M12 4.5v15m7.5-7.5h-15"
                          />
                        </svg>
                        <label className="text-xs lg:text-sm font-medium">
                          {t("button.newParam")}
                        </label>
                      </div>
                    </button>
                  ) : null}
                </div>

                {asset?.alarms &&
                  asset?.alarms.length > 0 &&
                  asset.alarms.some(
                    (a) => a.parameterId === item.parameterId
                  ) && (
                    <div className="flex gap-36">
                      <label className="dark:text-white text-labels font-medium text-xs lg:text-sm py-1">
                        {t("masters.headerTexts.alarms")}
                      </label>
                    </div>
                  )}
                {asset &&
                  asset?.alarms &&
                  asset?.alarms.map(
                    (i, index) =>
                      i.parameterId === item.parameterId && (
                        <div className="flex flex-col py-1">
                          <div class=" dark:bg-neutral-800 bg-neutral-500 rounded-lg w-11/12 lg:w-fit h-fit px-3 py-2">
                            <div className="flex gap-6 ml-1 pt-2">
                              <div className="flex flex-col gap-3 text-xs lg:text-sm py-1 w-40 pr-3 border-r-2 border-zinc-700">
                                <div className="flex w-24">
                                  <label className="text-white text-xs lg:text-sm font-medium">
                                    {t("masters.fields.alrmName")}
                                  </label>
                                </div>
                                <div className="flex w-36">
                                  <label>{i.alarmName}</label>
                                </div>
                              </div>
                              {/* Alarm Info */}
                              {i.infoEnabled === true &&
                                (i.parameterType === "String" ||
                                i.parameterType === "Boolean" ? (
                                  <AlarmInfo
                                    label={t("masters.fields.info")}
                                    value={i.infoSensorValue}
                                    text={i.infoAlarmText}
                                    t={t}
                                  />
                                ) : i.parameterType === "Number" ? (
                                  <AlarmLimit
                                    label={t("masters.fields.info")}
                                    min={i.infoLowerLimit}
                                    max={i.infoUpperLimit}
                                    t={t}
                                  />
                                ) : i.parameterType === "GeoLocation" ? (
                                  <AlarmKmRange
                                    label={t("masters.fields.info")}
                                    value={i.infoKMRange}
                                    t={t}
                                  />
                                ) : null)}

                              {/* Warning Info */}
                              {i.warningEnabled === true &&
                                (i.parameterType === "String" ||
                                i.parameterType === "Boolean" ? (
                                  <AlarmInfo
                                    label={t("masters.fields.warning")}
                                    value={i.warningSensorValue}
                                    text={i.warningAlarmText}
                                    t={t}
                                  />
                                ) : i.parameterType === "Number" ? (
                                  <AlarmLimit
                                    label={t("masters.fields.warning")}
                                    min={i.warningLowerLimit}
                                    max={i.warningUpperLimit}
                                    t={t}
                                  />
                                ) : i.parameterType === "GeoLocation" ? (
                                  <AlarmKmRange
                                    label={t("masters.fields.warning")}
                                    value={i.warningKMRange}
                                    t={t}
                                  />
                                ) : null)}

                              {/* Critical Info */}
                              {i.criticalEnabled === true &&
                                (i.parameterType === "String" ||
                                i.parameterType === "Boolean" ? (
                                  <AlarmInfo
                                    label={t("masters.fields.critical")}
                                    value={i.criticalSensorValue}
                                    text={i.criticalAlarmText}
                                    t={t}
                                  />
                                ) : i.parameterType === "Number" ? (
                                  <AlarmLimit
                                    label={t("masters.fields.critical")}
                                    min={i.criticalLowerLimit}
                                    max={i.criticalUpperLimit}
                                    t={t}
                                  />
                                ) : i.parameterType === "GeoLocation" ? (
                                  <AlarmKmRange
                                    label={t("masters.fields.critical")}
                                    value={i.criticalKMRange}
                                    t={t}
                                  />
                                ) : null)}

                              {/* Edit Button */}
                              <div className="flex justify-center items-center">
                                <div className="flex h-10 w-9 mr-2 dark:bg-neutral-900 bg-zinc-800 justify-center items-center rounded-lg">
                                  <button
                                    type="button"
                                    onClick={(e) => onAlarmDelete(e, index)}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      class="w-4 h-4"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                      />
                                    </svg>
                                  </button>
                                </div>
                                <div className="flex h-10 w-9 mr-2 dark:bg-neutral-900 bg-zinc-800 justify-center items-center rounded-lg">
                                  <button
                                    type="button"
                                    onClick={(e) =>
                                      onEditAlarm(e, item, index, i)
                                    }
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      class="w-4 h-4"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                  )}
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col relative h-fit left-0 top-0 justify-center items-center">
          <div className=" w-full h-1/2 relative">
            <label className="dark:text-white text-labels">
              Asset Map Icon
            </label>
            <input
              type="file"
              accept="image/*"
              className="absolute left-0 top-0 documents cursor-pointer h-full w-full border-0 focus:outline-none opacity-0"
              onChange={(e) => handleFileChange(e, "mapIconId")}
            />
            {loading.imageLoading ? (
              <div>
                <span class="inline-flex items-center gap-px">
                  <span class="animate-blink mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                  <span class="animate-blink animation-delay-200 mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                  <span class="animate-blink animation-delay-[400ms] mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                </span>
              </div>
            ) : asset.mapIconId && !asset.mapIconId.startsWith("0000") ? (
              <div className="h-32 flex justify-center items-center">
                <img
                  src={`${BASE_FILE_URL}/${asset.mapIconId}`}
                  alt="AssaetTypeIcon"
                  className="h-auto self-center w-auto image-full hover:fill-white"
                />
              </div>
            ) : (
              <div className="h-32 flex justify-center items-center">
                <img
                  src="upload_asset_logo.svg"
                  alt="AsseeetTypeIcon1"
                  className=" w-6 hover:fill-white self-center bg-neutral-800"
                />
              </div>
            )}
          </div>
          <div className=" w-full h-1/2 relative">
            <label className="dark:text-white text-labels">Asset Image</label>
            <input
              type="file"
              accept="image/*"
              className="absolute left-0 top-0 documents cursor-pointer h-full w-full border-0 focus:outline-none opacity-0"
              onChange={(e) => handleFileChange(e, "imageId")}
            />
            {loading.imageLoading ? (
              <div>
                <span class="inline-flex items-center gap-px">
                  <span class="animate-blink mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                  <span class="animate-blink animation-delay-200 mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                  <span class="animate-blink animation-delay-[400ms] mx-px h-1.5 w-1.5 rounded-full bg-neutral-600"></span>
                </span>
              </div>
            ) : asset.imageId && !asset.imageId.startsWith("0000") ? (
              <img
                src={`${BASE_FILE_URL}/${asset.imageId}`}
                alt="AssaetTypeIcon"
                className="h-[40vh] w-auto image-full hover:fill-white"
              />
            ) : (
              <div className="h-32 flex justify-center items-center">
                <img
                  src="upload_asset_logo.svg"
                  alt="AsseeetTypeIcon1"
                  className=" w-6 hover:fill-white bg-neutral-800"
                />
                {/* <ReactSVG
                  src="upload_asset_logo.svg"
                  className="w-6 hover:fill-white dark:bg-neutral-800 flex items-center justify-center "
                  beforeInjection={(svg) => {
                    svg.setAttribute(
                      "style",
                      `fill: ${darkMode ? "white" : "black"}`
                    );
                  }}
                ></ReactSVG> */}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex items-center dark:bg-inherit bg-lightModeBg mt-7 py-1 gap-3 fixed bottom-0 w-full pl-10 justify-center z-10">
        <div class="flex justify-center form-check form-check-inline mr-2">
          <label
            className="form-check-label inline-block text-xs lg:text-sm dark:text-white text-labels mr-3 mt-1"
            for="inlineCheckbox1"
          >
            {t("masters.fields.active")}
          </label>
          <input
            name="active"
            type="checkbox"
            className="focus:ring-blue-500 h-4 lg:h-5 w-4 lg:w-5 text-blue-600 border-gray-300 rounded mt-1"
            id="inlineCheckbox1"
            // defaultChecked={true}
            onChange={onCheckBox}
            checked={asset.active}
            value={asset.active}
          ></input>
        </div>
        <button
          type="button"
          onClick={onCloseClick}
          className="dark:bg-white bg-closeBtns dark:text-black text-closeBtnTxts text-xs lg:text-sm rounded-4xl px-10 lg:w-48 h-10"
        >
          {t("button.cancel")}
        </button>
        <button
          type="button"
          className="dark:bg-indigo-700 bg-submitBtns dark:text-white text-submitBtnTxts text-xs lg:text-sm rounded-4xl disabled:opacity-40 px-10 lg:w-48 h-10 flex justify-center items-center gap-3"
          onClick={() => onSubmit()}
          disabled={
            loading.formLoading ||
            asset?.name === "" ||
            asset.parameters.some((p) => p.parameterId === "")
          }
        >
          {loading.formLoading && <BtnLoader />}
          {asset.id ? t("button.update") : t("button.create")}
        </button>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </div>
  );
};
